import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import { confirmMileageThen, confirmSuspiciousMileage } from "@/utils/mileageValidation.js";
var moment = require("moment");
  export default {
    components: {
      VueBootstrapTypeahead
    },
    filters: {
      region: function(data){
        return VehicleRegistrationRegion(data);
      }
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        mileageConfirmed: false,
        confirmedMileageValue: null,
        SearchKey: "",
        Vehicles:[],
        Groups:[],
        Branches:{},
        VehicleClasses:{},
        MileageUnit:"Mileage",
        NewVehicle: {
          branch_id:0,
          fleet_group_id:0,
          adhoc:false,
          vrm: "",
          date_reg_uk: "",
          make: "",
          model: "",
          year: "",
          class: "",
          color: "",
          engine_number: "",
          fuel_type: "",
          drive_type: "",
          body_type: "",
          engine_capacity: "",
          transmission: "",
          vin: "",
          keepers: "",
          fleet_number: "",
          current_mileage: "",
          mot_due: "",
          tax_due: "",
          insurance_expiry: "",
          last_pmi_date:"",
          next_pmi_due:"",
          lastservice_mile: "",
          lastservice_date: "",
          nextservice_mile: "",
          nextservice_date: "",
          tracker_status: "No_Tracker",
          company_vehicle_type: "Fleet",
          registration_region:"UK",
          fuel_status: "Fuel",
          tracker_company: null,
          inseego_node_id: "",
          contract_start_date: "",
          contract_end_date: "",
          FleetSubscription:[],
          isCVRT:false,
          fuel_card_number:"",
          create_data_with:"Create",
        },
        FuelTrackingModule: false,
        select_branch:true,
        FleetSubscriptionModules:[]     
      };
    },
    validations: {
      NewVehicle: {
        vrm: { required },
        date_reg_uk: { required },
        make: { required },
        model: { required },
        year: { required },
        class: { required },
        //color: { required },
        //engine_number: { required },
        //fuel_type: { required },
        //drive_type: { required },
        //body_type: { required },
        //engine_capacity: { required },
        //transmission: { required },
        //keepers: { required },
        //vin: { required },
      },
    },
    mounted() {
      //check account permission
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
        );
        this.FleetSubscription = JSON.parse(
          localStorage.getItem("FleetSubscription")
        );
        var FleetSubscriptionModules = JSON.parse(
          this.FleetSubscription.fleet_modules
        );

        this.FuelTrackingModule = FleetSubscriptionModules["Fuel Tracking"];
        
        this.FleetSubscriptionModules = FleetSubscriptionModules;
      if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Vehicle || !AccountPermissions.Vehicle.enable || !AccountPermissions.Vehicle.add) ){
        this.$router.push('/');
      }

      document.title = pbx_SiteTitle + " - Vehicle Add";
      this.GetGroups();
      this.GetVehicleFleetNumber();
      
      // Not used currently
      //this.GetVehiclesList();
      this.GetBranches();
      this.GetVehicleClasses();

      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      if(CompanyData && CompanyData.mileage_unit == 2){
        this.MileageUnit = 'KM';
      }
    },
    watch: {
      "NewVehicle.current_mileage"() {
        this.mileageConfirmed = false;
        this.confirmedMileageValue = null;
      },
    },

    methods: {
      checkNextPMI(){
        var obj = {
          token: localStorage.getItem("token"),
          date: this.NewVehicle.last_pmi_date,
        };
        Axios.post(Endpoints.Vehicle.CalculateNextPmi, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.NewVehicle.next_pmi_due = Response?.data?.date || "";
          }
        });
      },
      GetGroups() {
        var obj = {
          token: localStorage.getItem("token"),
        };
        Axios.post(Endpoints.Groups.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Groups = Response.data.records;
          }
        });
      },
      GetVehicleClasses(){
        if(localStorage.getItem("Classes")){
          this.VehicleClasses = JSON.parse(localStorage.getItem("Classes"));
        }else{
          var obj = { token: localStorage.getItem("token"), simple_list:true };
          Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, obj).then((Response) => {
            if (Response?.data?.success) {
              this.VehicleClasses = Response.data.records;
            }
          });
        }
      },
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch:true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
            if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
              this.NewVehicle.branch_id = this.Branches[0].id;
              this.select_branch = false;
            }

          }
        });
      },
      // GetVehiclesList(){
      //   var obj={token: localStorage.getItem('token')}
      //   Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
      //     if (Response?.data?.success) {
      //       Response.data.vehicles.forEach((element) => {
      //         this.Vehicles.push(element.vrm);
      //       });
      //     }
      //   })
      // },	
      GetVehicleFleetNumber() {
        Axios.post(Endpoints.Vehicle.GetVehicleFleetNumber, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          this.NewVehicle.fleet_number = Response?.data?.fleetnumber || "";
        });
      },
      SearchRegistration() {
        this.$swal.fire({
          title: "Searching...",
          text: "Please wait...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        this.SearchKey = this.SearchKey.toUpperCase();
        var isIreland = false;
        if ( typeof this.SearchKey === "string" && this.SearchKey.length > 0 &&
            Number.isInteger(parseInt(this.SearchKey.charAt(0)))
        ) {
            isIreland = true;
        }
        
        this.NewVehicle.isCVRT = false;
        this.NewVehicle.registration_region = "UK";
        Axios.post(Endpoints.Vehicle.Data, {
          token: localStorage.getItem("token"),
          vehicle: this.SearchKey,
          mot_tax: 1,
          isIreland: isIreland,
        }).then((Response) => {
          if (!Response?.data?.vehicle) {
            this.NewVehicle.vrm = "";
            this.NewVehicle.date_reg_uk ="";
            this.NewVehicle.make = "";
            this.NewVehicle.model = "";
            this.NewVehicle.year ="";
            this.NewVehicle.class = "";
            this.NewVehicle.color = "";
            this.NewVehicle.engine_number ="";
            this.NewVehicle.fuel_type = "";
            this.NewVehicle.drive_type = "";
            this.NewVehicle.body_type = "";
            this.NewVehicle.engine_capacity ="";
            this.NewVehicle.transmission = "";
            this.NewVehicle.vin = "";
            this.NewVehicle.keepers ="";
            this.NewVehicle.mot_due = "";
            this.NewVehicle.tax_due = "";
            this.NewVehicle.isCVRT = false;
            this.$swal.fire({
              title: "Oops!",
              text: "No Data Found!",
              icon: "error",
              confirmButtonText: "Close",
            });
          } else if(isIreland) {
            this.$swal.close();
            const vehicle = Response?.data?.vehicle;
            this.NewVehicle.vrm = vehicle?.reg?.toUpperCase() || "";
            this.NewVehicle.date_reg_uk = vehicle?.reg_date || "";
            this.NewVehicle.make = vehicle?.make || "";
            this.NewVehicle.model = vehicle?.model || "";
            this.NewVehicle.year = vehicle?.year_of_manufacture || "";
            this.NewVehicle.class = vehicle?.body || "";
            this.NewVehicle.color = vehicle?.colour || "";
            this.NewVehicle.engine_number = vehicle?.engine_no || "";
            this.NewVehicle.fuel_type = vehicle?.fuel || "";
            this.NewVehicle.drive_type = vehicle?.transmission || "";
            this.NewVehicle.body_type = vehicle?.body || "";
            this.NewVehicle.engine_capacity = vehicle?.engine_cc || "";
            this.NewVehicle.transmission = vehicle?.transmission || "";
            //this.NewVehicle.vin = vehicle.VehicleRegistration.VinLast5;
            this.NewVehicle.keepers = vehicle?.no_of_owners || "";            
            this.NewVehicle.tax_due = vehicle?.tax_expiry_date || "";
            this.NewVehicle.registration_region = "IRL";
            this.NewVehicle.mot_due = vehicle?.NCT_expiry_date || "";
            if(vehicle?.body=='VAN'){
            	this.NewVehicle.mot_due = vehicle?.crwExpDate || "";
            }
            var NCT_expiry_dateValid = moment(vehicle?.NCT_expiry_date);
            var crwExpDateValid = moment(vehicle?.crwExpDate);
            if(!NCT_expiry_dateValid.isValid() && crwExpDateValid.isValid()){
              this.NewVehicle.mot_due = vehicle?.crwExpDate || "";
              this.NewVehicle.isCVRT = true;
            }
          }else {
            this.$swal.close();
            const vehicle = Response?.data?.vehicle;
            this.NewVehicle.vrm = vehicle?.VehicleRegistration?.Vrm?.toUpperCase() || "";
            this.NewVehicle.date_reg_uk =
              vehicle?.VehicleRegistration?.DateFirstRegisteredUk?.split("T")[0] || "";
            this.NewVehicle.make = vehicle?.VehicleRegistration?.Make || "";
            this.NewVehicle.model = vehicle?.VehicleRegistration?.Model || "";
            this.NewVehicle.year =
              vehicle?.VehicleRegistration?.YearOfManufacture || "";
            this.NewVehicle.class = vehicle?.VehicleRegistration?.VehicleClass || "";
            this.NewVehicle.color = vehicle?.VehicleRegistration?.Colour || "";
            this.NewVehicle.engine_number =
              vehicle?.VehicleRegistration?.EngineNumber || "";
            this.NewVehicle.fuel_type = vehicle?.VehicleRegistration?.FuelType || "";
            this.NewVehicle.drive_type = vehicle?.SmmtDetails?.DriveType || "";
            this.NewVehicle.body_type = vehicle?.SmmtDetails?.BodyStyle || "";
            this.NewVehicle.engine_capacity =
              vehicle?.VehicleRegistration?.EngineCapacity || "";
            this.NewVehicle.transmission = vehicle?.SmmtDetails?.Transmission || "";
            this.NewVehicle.vin = vehicle?.VehicleRegistration?.VinLast5 || "";
            this.NewVehicle.keepers =
              (Number(vehicle?.VehicleHistory?.NumberOfPreviousKeepers) + 1) || "";
            this.NewVehicle.mot_due = vehicle?.mot_due || "";
            this.NewVehicle.tax_due = vehicle?.tax_due || "";
          }
        });
      },
      CreateVehicle() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (this.Saving) {
          return;
        }
        this.Saving = true;
        confirmMileageThen(
          this,
          {
            vrm: this.NewVehicle.vrm,
            current_mileage: this.NewVehicle.current_mileage,
          },
          () => this.submitCreateVehicle(),
          () => {
            this.Saving = false;
          }
        );
      },
      submitCreateVehicle() {
        if(this.NewVehicle.tracker_status != "Tracker_Fitted"){
          this.NewVehicle.tracker_company = "";
          this.NewVehicle.contract_start_date = "";
          this.NewVehicle.contract_start_date = "";
        }
        Axios.post(Endpoints.Vehicle.Create, {
          token: localStorage.getItem("token"),
          ...this.NewVehicle,
          mileage_confirmed: this.mileageConfirmed ? 1 : 0,
        }).then((Response) => {
          this.Saving = false;
          if (Response?.data?.warning) {
            confirmSuspiciousMileage(this, Response.data.message).then((confirmed) => {
              if (confirmed) {
                this.mileageConfirmed = true;
                this.confirmedMileageValue = this.NewVehicle.current_mileage;
                this.Saving = true;
                this.submitCreateVehicle();
              }
            });
            return;
          }
          if (Response?.data?.success) {
            if (Response?.data?.vehicle == "Deleted") {
              this.$swal.fire({
                title: "Vehicle already exists but deleted",
                html: `
                  <div style="text-align:left">
                    <label>
                      <input type="radio" name="vehicleOption" value="Active" checked />
                      Mark this vehicle active
                    </label>
                    <br/>
                    <label>
                      <input type="radio" name="vehicleOption" value="ActiveWithNewData" />
                      Mark active with new data
                    </label>
                  </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Add",
                preConfirm: () => {
                  const selectedOption = document.querySelector(
                    'input[name="vehicleOption"]:checked'
                  ).value;
                  return selectedOption;
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  this.NewVehicle.create_data_with = result.value;

                  Axios.post(Endpoints.Vehicle.Create, {
                    token: localStorage.getItem("token"),
                    ...this.NewVehicle,
                    mileage_confirmed: this.mileageConfirmed ? 1 : 0,
                  }).then(() => {
                    this.$swal.fire("Vehicle Added Successfully", "", "success").then(() => {
                      this.$router.push("/vehicles-list");
                    });
                  });
                }
              });

            } else {
              this.$swal
                .fire("Vehicle Added Successfully", "", "success")
                .then(() => {
                  this.$router.push("/vehicles-list");
                });
            }
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      SetVehicleTrackerStatus(type) {
        this.NewVehicle.tracker_status = type;
      },
      SetVehicleType(type){
        this.NewVehicle.company_vehicle_type=type
      },
      SetVehicleRegistrationRegion(type){
        this.NewVehicle.registration_region=type
      },
      SetFuelStatus(type) {
        this.NewVehicle.fuel_status = type;
      },
      onSelectTrackerCompany() {
      	if(this.NewVehicle.tracker_company != 'Other'){
	      	this.$swal.fire({
	          title: "Fetching data ...",	          
	          text: "Please wait...",	          
	          showConfirmButton: false,
	          allowOutsideClick: false,
	        });
	        var obj = { 
	        	token: localStorage.getItem("token"), 
	        	vehicle_vrm: this.NewVehicle.vrm,
	        	tracker_company: this.NewVehicle.tracker_company 
	    	};
	        Axios.post(Endpoints.Vehicle.GetInseegoData, obj).then((Response) => {
	          this.ShowLoader = false;
	          if (Response?.data?.success) {
          	this.NewVehicle.inseego_node_id = Response?.data?.NodeId || "";
	            this.$swal.fire(Response?.data?.message || "Something went wrong", "", "success");
	          }else{
	          	this.$swal.close();
	          }
	        });
	    }else{
	    	this.NewVehicle.inseego_node_id = null;
	    }     
      }, 
    },
  };